var React = require('react');

function Locate (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-1102.000000, -5210.000000)","fill":"#A5B5BE","fillRule":"nonzero"},React.createElement("g",{"transform":"translate(150.000000, 5209.000000)"},React.createElement("g",{"transform":"translate(780.000000, 1.000000)"},React.createElement("g",{"transform":"translate(172.000000, 0.000000)"},React.createElement("path",{"d":"M8,0 C3.54285714,0 0,3.565 0,8.05 C0,14.03 8,23 8,23 C8,23 16,14.03 16,8.05 C16,3.565 12.4571429,0 8,0 Z M8,10.925 C6.4,10.925 5.14285714,9.66 5.14285714,8.05 C5.14285714,6.44 6.4,5.175 8,5.175 C9.6,5.175 10.8571429,6.44 10.8571429,8.05 C10.8571429,9.66 9.6,10.925 8,10.925 Z"})))))));
}

Locate.defaultProps = {"width":"16px","height":"23px","viewBox":"0 0 16 23","version":"1.1"};

module.exports = Locate;

Locate.default = Locate;
